import angular from "angular";
import template from "./admin-school-view-vehicle.html";
import AdminSchoolsVehiclesViewController from "./admin-school-view-vehicle.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.schools.vehicles.view", {
    url: "/view/:vehicleId",
    controller: AdminSchoolsVehiclesViewController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.schools.vehicles.view", [])
  .config(config)
  .controller(
    "AdminSchoolsVehiclesViewController",
    AdminSchoolsVehiclesViewController,
  );
